import { useState } from 'react'
import {
  Platform,
  Pressable,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View
} from 'react-native'
import { ParamListBase, useNavigation } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { Ionicons, FontAwesome } from '@expo/vector-icons'

// components
import ModalPopup from '../shared/modal/ModalPopup'
import CustomButton from '../shared/button/Button'
import {
  colorPalette,
  fontPalette,
  globalStyles
} from '../../static/styles/global'

interface scheduleTimePickerProps {
  title?: string
  visible: boolean
  setVisible: any
  scanDocumentsAction?: any
  photoLibraryAction?: any
  importFilesAction?: any
  description?: string
  essUserOnBoardingKey?: number
  essUserOnBoardingFormKey?: number
}

const ScanOrUploadDeposit = ({
  title,
  visible,
  setVisible,
  scanDocumentsAction,
  photoLibraryAction,
  importFilesAction,
  description,
  essUserOnBoardingKey,
  essUserOnBoardingFormKey
}: scheduleTimePickerProps): JSX.Element => {
  const navigation = useNavigation<NativeStackNavigationProp<ParamListBase>>()

  const handleScanDocument = (): void => {
    setVisible(!visible)
    setTimeout(() => {
      navigation.navigate('CameraStack', {
        description,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
      })
    }, 200)
  }

  return (
    <ModalPopup visible={visible} position={'bottom'} screen={'full'}>
      <View style={styles.modalHeader}>
        <Text
          style={[
            globalStyles.text,
            globalStyles.fs18,
            globalStyles.fwBold,
            globalStyles.blackTextColor
          ]}
        >
          {title}
        </Text>
        <TouchableOpacity onPress={() => setVisible(!visible)}>
          <Ionicons name="close-sharp" size={24} color={colorPalette.black} />
        </TouchableOpacity>
      </View>
      <View style={[styles.modalBody]}>
        <View
          style={[globalStyles.verticalPadGap, globalStyles.horizontalPadGap]}
        >
          {Platform.OS !== 'web' && (
            <View style={[globalStyles.mb2]}>
              <CustomButton
                text="Take Photo(s)"
                onPress={handleScanDocument}
                icon="camera-outline"
                iconPosition="left"
              />
            </View>
          )}
          <View style={[globalStyles.mb2]}>
            <CustomButton
              text="Photo Library"
              onPress={photoLibraryAction}
              color={'secondary'}
              icon="images-outline"
              iconPosition="left"
            />
          </View>
          <View style={[globalStyles.mb2]}>
            <CustomButton
              text="Import File(s)"
              onPress={importFilesAction}
              color={'gray'}
              icon="folder-outline"
              iconPosition="left"
            />
          </View>
          <View style={[globalStyles.mb2]}>
            <CustomButton
              text="Cancel"
              onPress={() => setVisible(!visible)}
              color={'light'}
            />
          </View>
        </View>
      </View>
    </ModalPopup>
  )
}

const styles = StyleSheet.create({
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: colorPalette.darkLight
  },
  modalBody: {
    paddingVertical: 0,
    paddingHorizontal: 0
  }
})

export default ScanOrUploadDeposit
